import { render, staticRenderFns } from "./TakeawayOrderList.vue?vue&type=template&id=5f0a4e46&"
import script from "./TakeawayOrderList.vue?vue&type=script&lang=js&"
export * from "./TakeawayOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports